import { clearMessages } from "../webbot";

export default ({ functions }) => {
  const { dispatch } = functions;

  dispatch(clearMessages());
};
